// extracted by mini-css-extract-plugin
export default {"toc":"m_bd","h3toc":"m_bf","linkText":"m_bg","tocTitle":"m_bh"};